import React from 'react'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import { CrossIcon } from '../Icons'

const DocumentMenuActions = ({open, selectedDocuments, onClose, onUpdate, onRemove, onSendReminders}) => {
  const { t } = useTranslation()

  const docIds = new Set(selectedDocuments.map(doc => doc.document_id))
  const canSendReminders = selectedDocuments.every(doc => doc.employee_id != null)

  return (
    <div className={cn(styles.container, { [styles.open]: open })}>
      <div>{t('{{count}} selected', { count: selectedDocuments.length })}</div>
      <div className={styles.divider} />
      <button
        type="button"
        className={styles.actionButton}
        disabled={!canSendReminders}
        onClick={() => onSendReminders(selectedDocuments)}
      >
        {t('Send reminder')}
      </button>
      <button type="button" className={styles.actionButton} disabled={docIds.size > 1} onClick={() => onUpdate(docIds.values().next().value)}>
        {t('Update document')}
      </button>
      <button type="button" className={styles.actionButton} onClick={() => onRemove(selectedDocuments)}>
        {t('Delete documents')}
      </button>
      <button type="button" className={styles.closeButton} onClick={onClose}>
        <CrossIcon />
      </button>
    </div>
  )
}

export default DocumentMenuActions
